import {
  RoadmapEventStatuses,
  getRoadmapEventStatusesColor,
} from '@/typings/api/RoadmapEvent'


export const TABLE_HEADERS = Object.freeze([
  {
    text: '',
    value: 'name',
  },

  {
    text: 'Количество',
    value: 'count',
    width: 80,
  },
  {
    text: 'Выполнение',
    value: 'in_progress_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.inProgress)}`,
  },
  {
    text: 'Не&nbsp;выполнено',
    value: 'expired_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.expired)}`,
  },
  {
    text: 'Выполнено',
    value: 'done_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.done)}`,
  },
  {
    text: 'Требуется доработка',
    value: 'need_works_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.needsWork)}`,
  },
  {
    text: 'Подтверждено',
    value: 'confirmed_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.confirmed)}`,
  },
  {
    text: 'Не&nbsp;подтверждено',
    value: 'unconfirmed_count',
    width: 80,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.expired)}`,
  },
])
